export class TimeMapper {
    /**
     *
     * @param obj {Object}
     * @param targetKey {string}
     * @param separators {Array<string>}
     * @return {Object}
     * @private
     */
    static _setValueTimeInObj(obj, targetKey, separators = ["/", "/", "-", ":"]) {
        if (obj[targetKey] && obj[targetKey] !== '') {
            obj[targetKey] = this.SetFormatDate(obj[targetKey], false, separators, true)
        } else {
            obj[targetKey] = "-"
        }
        return obj
    }

    /**
     *
     * @param dateString {string}
     * @param withMonthName {boolean} // if true gonna be with Name, otherwise digit such as 11, 09
     * @param separators {Array<String>} // to combination date if u need with "-" or "/" or just space " "
     * @param showClock {boolean} // if true gonna show the clock of time such as 16:30, 04:09
     * @param isLangId {boolean} // if true gonna show the month name in bahasa
     * @return {string}
     * @constructor
     */
    static SetFormatDate(dateString, withMonthName, separators = ["/", "/", "-", ":"], showClock = false, formatDatePublished = false, isLangId = false, shortMonthName = false) {
        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        const monthNamesId = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", 
            "Juli", "Agustus", "September", "Oktober", "November", "Desember"
        ]

        const  monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        const  monthShortNamesId = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun",
            "Jul", "Agu", "Sep", "Okt", "Nov", "Des"
        ];

        const t = new Date(dateString)

        // set the month of date either with digit or custom name :)
        let getMonth = ("0" + (t.getMonth() + 1)).slice(-2);
        if (withMonthName) {
            if (shortMonthName) {
                getMonth = isLangId ? monthShortNamesId[t.getMonth()] : monthShortNames[t.getMonth()]
            } else if (isLangId) {
                getMonth = monthNamesId[t.getMonth()]
            } else {
                getMonth = monthNames[t.getMonth()]
            }
        }


        // set the final of time
        const finalTime = ("0" + t.getDate()).slice(-2) + separators[0] + getMonth + separators[1] + t.getFullYear();
        const withClock = finalTime + " " + separators[2] + " " + ("0" + t.getHours()).slice(-2) +
            separators[3] + ("0" + t.getMinutes()).slice(-2)

        // set format published time
        if (formatDatePublished) {
            const date = t.getFullYear() + separators[0] + getMonth + separators[1] +  ("0" + t.getDate()).slice(-2);
            const dateTime = date + " " + ("0" + t.getHours()).slice(-2) +
            separators[2] + ("0" + t.getMinutes()).slice(-2) + separators[2] + ("0" + t.getSeconds()).slice(-2)

            return dateTime
        }

        return showClock ? withClock : finalTime
    }

    static SetFormatTime(dateString, separators = ':') {
        const t = new Date(dateString)

        return ("0" + t.getHours()).slice(-2) + separators + ("0" + t.getMinutes()).slice(-2)
    }

    /**
     *
     * @param obj {Object}
     * @param listKey {Array<string>}
     * @return {Object}
     * @constructor
     */
    static SetKeyOfTheValueToTime(obj, listKey) {
        for (let key of listKey) {
            this._setValueTimeInObj(obj, key.trim())
        }
        return obj
    }

    /**
     *
     * @param inDate {Date}
     * @return {string}
     * @example
     * TimeMapper.GetDayName(new Date().setDate(1)) // "Sunday"
     */
    static GetDayName(inDate = new Date()) {
        const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        return dayNames[inDate.getDay()]
    }

    static GetDayNameId(inDate = new Date()) {
        const dayNames = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
        return dayNames[inDate.getDay()]
    }

    static GetActualTime(dateString, timezone) {
      const t = new Date(dateString)
      const currentTime = new Date()

      let utcOffset = Number(timezone.replace("GMT+", "").replace(":", "").replaceAll('0', ''))
      let currentutcoffset = Number(currentTime.toString().split(' ')[5].replaceAll('0', '').replace('+', '').replace('GMT', ''))

      const finalOffset = utcOffset - currentutcoffset
      const oneHour = 3600000

      return new Date(t.getTime() + (finalOffset * oneHour))

    }

    static GetTimeZoneName(timezone = "") {
        switch (timezone) {
            case "+00:00":
            case "GMT+0000":
            case "GMT+0:00":
              return { id: "UTC" };
            case "+07:00":
            case "GMT+0700":
            case "GMT+7:00":
            case "GMT+07:00":
              return { id: "WIB" };
            case "+08:00":
            case "GMT+0800":
            case "GMT+8:00":
            case "GMT+08:00":
              return { id: "WITA", my: "MYT" };
            case "+09:00":
            case "GMT+0900":
            case "GMT+9:00":
            case "GMT+09:00":
              return { id: "WIT" };
        
            default:
              return { id: "", my: "" };
        }
    }
}
